import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { useNavigationContext } from '3-foundation/Navigation/NavigationContext';
import { PageContext } from '3-foundation/PageContent/PageContext';
import { useContext } from 'react';
import { BreadcrumbProps, UI_Breadcrumb } from 'ui/components/2-molecules/Navigation/Breadcrumb/Breadcrumb';

export const Breadcrumb = ({
	background,
	additionalBreadcrumbItems,
}: {
	background?: BreadcrumbProps['background'];
	additionalBreadcrumbItems?: BreadcrumbProps['breadcrumbItems'];
}) => {
	const navContext = useNavigationContext();
	const pageContext = useContext(PageContext);
	const dictionary = useDictionaryContext();

	const breadcrumbItems = navContext?.getBreadcrumb({ currentUrl: pageContext.path, includeRootItem: true });

	if (!breadcrumbItems.length) return null;

	const mappedItems = breadcrumbItems.map((item, index) => ({
		title: item.title && item.title !== '' ? item.title : index === 0 ? dictionary.getLabel('HomePage') : `${item.name}`,
		url: item.url,
	}));

	return (
		<UI_Breadcrumb
			background={background}
			breadcrumbItems={additionalBreadcrumbItems ? [...mappedItems, ...additionalBreadcrumbItems] : mappedItems}
		/>
	);
};
